module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Julia_480x480.4fd36d32.mp4";